import React from 'react';

const HomePage = () => {
    return (
        <div className="container d-flex flex-column justify-content-center align-items-center" style={{ height: '100vh' }}>
            
        </div>
    );
};

export default HomePage;